import React from 'react';
import styled from 'styled-components';

import { LinkButton } from '../LinkButton';
import { Title } from '../Title';
import { Text } from '../Text';

import { pushToDataLayer } from '../../../utils';
import { breakpoints, colors } from '../../../constants';

interface IProps {
    className?: string;
}

const BaseAppointmentSection = ({ className }: IProps) => {
    const handleButtonClick = () => {
        pushToDataLayer('Klik Maak een afspraak button', '');
    };

    return (
        <div className={className}>
            <img src="https://grandvision.s3.amazonaws.com/pnl/images/online-oogcheck/Goedzichtgesprek.svg" />
            <Title>Kijkgedrag</Title>
            <Text>
                Bij het Goed Zicht Gesprek verricht de opticien ook een
                oogmeting. In deze online oogcheck heb je kunnen proeven aan de
                onderdelen van een echte oogmeting bij Pearle. Onze
                gediplomeerde opticiens testen dan met geavanceerde apparatuur
                jouw zicht.
            </Text>
            <Text>
                Zie jij bijvoorbeeld alle openingen van de cirkels goed of gaat
                het wat lastiger? Kan je contrast en lijnen goed waarnemen of
                merk je dat je daar wat meer moeite mee hebt?
            </Text>
            <Text>
                Als jij er klaar voor bent, zijn wij dat ook en verwelkomen we
                je graag voor een Goed Zicht Gesprek.
            </Text>
            <LinkButton
                href="https://www.pearle.nl/afspraak-maken"
                onClick={handleButtonClick}
                target="_blank"
                rel="noopener noreferrer"
            >
                Maak een afspraak
            </LinkButton>
        </div>
    );
};

export const AppointmentSection = styled(BaseAppointmentSection)`
    position: relative;
    background-color: ${colors.greenDark};
    color: ${colors.white};
    padding: 120px 30px 30px;

    ${Title} {
        margin-bottom: 40px;
    }

    ${Text} {
        margin: 20px 0;
    }

    img {
        position: absolute;
        width: 200px;
        top: -50px;
        left: 50%;
        transform: translate(-50%, 0);
    }

    ${LinkButton} {
        margin-top: 40px;
    }

    @media (${breakpoints.smallMin}) {
        padding: 80px 40px 40px;
    }
`;
